import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../types/validation-function-result';
import { CreateUserDto } from '../../dtos/create-user.dto';
import { UpdateUserDto } from '../../dtos/update-user.dto';
import { createUserSchema } from '../schemas/create-user.schema';
import { updateUserSchema } from '../schemas/update-user.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateUserDto | UpdateUserDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateUserSchema if 'id' is present
		validationResult = updateUserSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createUserSchema if 'id' is not present
		validationResult = createUserSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
